const STORAGE_KEY = 'merchmuse-theme';

function getStoredMode(): 'light' | 'dark' | 'system' {
  try {
    const storedTheme = window.localStorage.getItem(STORAGE_KEY);

    if (!storedTheme) return 'system';

    const parsedTheme = JSON.parse(storedTheme) as { mode?: unknown };
    return parsedTheme.mode === 'light' || parsedTheme.mode === 'dark'
      ? parsedTheme.mode
      : 'system';
  } catch {
    return 'system';
  }
}

function resolveInitialMode(): 'light' | 'dark' {
  const storedMode = getStoredMode();
  if (storedMode !== 'system') return storedMode;

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyInitialMode(mode: 'light' | 'dark') {
  const root = document.documentElement;
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');

  root.classList.remove('light', 'dark');
  root.classList.add(mode);
  root.style.colorScheme = mode;

  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', mode === 'dark' ? '#0f172a' : '#f8fafc');
  }
}

applyInitialMode(resolveInitialMode());
